import { SvgIcon, SvgIconProps } from '@mui/material';

const ExportIcon = (props: SvgIconProps) => (
  <SvgIcon width="24" height="24" viewBox="0 0 32 32" fill="currentColor" {...props}>
    <path d="M21.333 32H0V0h21.333v8.889h-2.667V2.667h-16v26.667h16v-5.778h2.667V32zm3.61-22.6l-1.885 1.885 3.38 3.381H8.444v2.667h17.994l-3.38 3.38 1.885 1.885 6.6-6.599-6.6-6.6z" />
  </SvgIcon>
);

export default ExportIcon;
